import { createFeatureSelector, createSelector } from '@ngrx/store';
import { fromAdUser } from '../reducers';
export const getAdUserRootState = createFeatureSelector('adUser');
export const getAdUserState = createSelector(getAdUserRootState, state => state);
const adalUserSelectors = fromAdUser.adalUserAdapter.getSelectors(getAdUserState);
export const getAllAdUserItems = adalUserSelectors.selectAll;
export const getAdUserEntities = adalUserSelectors.selectEntities;
export const getAdUserEntitiesById = createSelector(getAllAdUserItems, (users) => users.reduce((entities, detail) => ({
    ...entities,
    [detail.objectId]: detail
}), {}));
export const getAdUserDetailsById = (id) => createSelector(getAdUserEntitiesById, entities => entities[id]);
export const getAdUserDetailsByEmail = (email) => createSelector(getAdUserEntities, entities => entities[fromAdUser.parseUserEmail(email)]);
/**
 * Selector to return the loading property of the state
 */
export const getAdalUserLoading = createSelector(getAdUserState, fromAdUser.getAdUserLoading);
export const getCurrentUserProfile = createSelector(getAdUserState, state => state && state.currentUser);
//# sourceMappingURL=ad-user.selectors.js.map